import { Typography12, Typography13 } from "@slid/slid-ips";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "hooks";
export const GuideTooltip = () => {
  const { t } = useTranslation("NoteMate");
  const { lang } = useAppSelector((state) => state.slidGlobal);

  return (
    <GuideTooltipContainer>
      <Typography12 weight={lang === "ko" ? 400 : 700} text={t("GuideTooltipSubContent")} color={`--gray17`} />
      <Typography13 weight={lang === "ko" ? 700 : 400} text={t("GuideTooltipContent")} color={`--gray17`} />
    </GuideTooltipContainer>
  );
};

const GuideTooltipContainer = styled.div`
  display: flex;
  width: max-content;
  padding: 8px 12px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid var(--blue3);
  background: var(--blue1);
`;
